
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindTrue6 as ObiWindTrue6Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-true-6.js';
 
 
 

 
 export const ObiWindTrue6 = createComponent({
   react: React,
   tagName: 'obi-wind-true-6',
   elementClass: ObiWindTrue6Element,
   events: {
     
   }
  });
 
 